
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class TaxCategoryDialog extends Serenity.EntityDialog<TaxCategoryRow, any> {
        protected getFormKey() { return TaxCategoryForm.formKey; }
        protected getIdProperty() { return TaxCategoryRow.idProperty; }
        protected getLocalTextPrefix() { return TaxCategoryRow.localTextPrefix; }
        protected getNameProperty() { return TaxCategoryRow.nameProperty; }
        protected getService() { return TaxCategoryService.baseUrl; }
        protected getDeletePermission() { return TaxCategoryRow.deletePermission; }
        protected getInsertPermission() { return TaxCategoryRow.insertPermission; }
        protected getUpdatePermission() { return TaxCategoryRow.updatePermission; }

        protected form = new TaxCategoryForm(this.idPrefix);

    }
}